import { Link, redirect, useLoaderData } from "react-router";

import { BugIcon } from "lucide-react";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

import LoginForm from "@/features/auth/components/LoginForm";
import { AuthLayout } from "@/pages/AuthLayout";
import { getFeatures } from "@/shared/lib/services/features";
import { getSession } from "@/shared/lib/utils/session";

export async function loginLoader() {
  const session = getSession();

  if (session) {
    throw redirect("/");
  }

  const { signUpEnabled } = await getFeatures();

  return { signUpEnabled };
}

export default function Login() {
  const { signUpEnabled } = useLoaderData<typeof loginLoader>();

  return (
    <AuthLayout maxWidth="max-w-lg" centerContent={false}>
      <div className="mb-6 text-center">
        <h1 className="font-heading text-2xl font-semibold tracking-tight">Welcome back</h1>
        {signUpEnabled && (
          <p className="mt-1.5 text-sm text-muted-foreground">
            Don't have an account?{" "}
            <Link to="/account/sign-up" className="font-medium text-primary underline underline-offset-4 transition-colors hover:text-primary/80">
              Sign up
            </Link>
          </p>
        )}
      </div>
      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <BugIcon className="size-4 text-primary" />
            <CardTitle>Sign in</CardTitle>
          </div>
          <CardDescription>Enter your email and password to access your account.</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-6">
          <LoginForm />
        </CardContent>
      </Card>
    </AuthLayout>
  );
}
